<script>
    import { mapGetters } from 'vuex'
    import MultiSelectWarehouse from '@components/retina/OwnMultiSelectWarehouse'
    import CardSelectWarehouse from './cardSelectWarehouse'
    
    export default {
      name: 'SelectWarehouse',
      components: { MultiSelectWarehouse, CardSelectWarehouse },
      data() {
        return {}
      },
      computed: {
        ...mapGetters({
          own_inventory_count_mode: 'retina/inventory/own_inventory_count_mode',
          own_warehouse_i: 'retina/inventory/own_warehouse_i',
          own_inventory_count_review: 'retina/inventory/own_inventory_count_review',
          own_inventory_online_mode: 'retina/inventory/own_inventory_online_mode',
          loading_inventory: 'retina/inventory/loading_inventory',
          own_consult_warehouse: 'retina/warehouse/own_consult_warehouse',
          own_warehouse_selected: 'retina/warehouse/own_warehouse_selected',
        }),
      },
      methods: {
        consultWarehouse() {
          return (!this.own_warehouse_selected) && (!this.own_warehouse_i) ? true 
            : this.own_inventory_count_mode
            ? false
            : this.own_inventory_count_review
            ? false
            : this.own_inventory_online_mode
            ? false
            : true
        },
      },
    }
    </script>
    <template>
      <div>
        <b-card v-if="consultWarehouse() && (!own_warehouse_selected)" no-body class="px-1 pb-0 mb-1">
          <MultiSelectWarehouse :onlyWithLocations="true" />
        </b-card>
        <CardSelectWarehouse />
      </div>
    </template>
    